import { IntersectionObserverManager } from '../../Common/Modules/observer.js';

// 活動報告ページの出現アニメーションの発火位置。
// 共通の observerManager（[data-observe] / rootMargin '-30% 0px 0px 0px'）は
// 下から入る要素を「上端が画面下端に触れた瞬間」に発火させるため、このページでは早すぎる。
// 共通側の設定を変えると他ページ（home / news / topics …）に波及するので、
// 属性を [data-observe-center] に分けて、このページ専用のインスタンスで拾う。

// 発火位置はここ1箇所で調整する。
// rootMargin の下側をマイナスにすると root の下端がその分だけ上がり、
// 要素の上端が「画面のその位置」まで来たときに発火する。
// -50% = 画面の縦中央。もっと手前で出したいなら -40%、遅らせたいなら -60% のように増やす
const REVEAL_MARGIN = '0px 0px -50% 0px';

// ページ末尾の要素用。判定ラインを画面中央に置くと、
// ドキュメント下端から半画面ぶんより下にある要素は
// 最後までスクロールしても上端が中央へ到達できず、永久に発火しない。
// そこで「画面に入ったら出す」に切り替える。ここは常に到達できる
const REVEAL_MARGIN_IN = '0px';

const reveal = {
  init() {
    // 対象が0件なら init() 側で早期 return する
    new IntersectionObserverManager({
      targetSelector: '[data-observe-center]',
      rootMargin: REVEAL_MARGIN,
      threshold: 0,
      once: true
    }).init();

    new IntersectionObserverManager({
      targetSelector: '[data-observe-in]',
      rootMargin: REVEAL_MARGIN_IN,
      threshold: 0,
      once: true
    }).init();
  }
}

export default reveal;
